import type { InferUITools, UIMessage } from 'ai';
import type { createCanvasTool } from './canvasTool';
import type { openai } from '@ai-sdk/openai';
import { z } from 'zod';

const canvasUserActionMetadataSchema = z.object({
  protocol_version: z.string(),
  origin_message_id: z.string(),
  surface_id: z.string(),
  surface_version: z.number(),
  client_action_id: z.string(),
  action_name: z.string(),
  source_component_id: z.string(),
  context: z.record(z.string(), z.unknown()).nullable().optional(),
  occurred_at: z.string().optional(),
});
export const chatMessageMetadataSchema = z.object({ responseId: z.string().optional(), canvasUserAction: canvasUserActionMetadataSchema.optional() });
export type ChatMessageMetadata = z.infer<typeof chatMessageMetadataSchema>;
export type ChatTools = InferUITools<{ canvas: ReturnType<typeof createCanvasTool>; web_search: ReturnType<typeof openai.tools.webSearch> }>;
export type ChatUIMessage = UIMessage<ChatMessageMetadata, never, ChatTools>;
